import $ from 'jquery'

export const init = async function (): Promise<void> {
  $('#js-custom-download-btn').on('click', function () {
    $('#js-custom-download-section').slideToggle('slow')

    const scrollTop = $('#js-custom-download-section').offset()?.top

    if (scrollTop == null) {
      console.warn(
        'Custom download section not found [c6a03bd9837d48e4adfa5b2fecf1affd]'
      )
      return
    }

    // TODO Don't use deprecated jQuery animate method
    $([document.documentElement, document.body]).animate({ scrollTop }, 2000)
  })
}
